import React from 'react';

import WpModal from 'Wpds/components/modal/WpModal';

import MeetingMode from 'Dashboard/components/MeetingMode/MeetingMode';

const WorkspaceMeetModal = () => {
  return (
    <WpModal isOpen size="full">
      <MeetingMode />
    </WpModal>
  );
};

export default WorkspaceMeetModal;
